import React from "react";
import UsersContent from "../components/users/users-content";

const Users = () => {
  return <UsersContent />;
};

export default Users;
